document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.features-swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            860: {
                slidesPerView: 2,
            }
        }
    });
});